<template>
  <main-layout :selectedMenu="'myHome'">
    <div class="container special-subject">
      <asideCom :activityIndex="5"></asideCom>
      <div class="my-content">
        <div class="name">{{ $t("global.我的频道") }}</div>
        <div class="top-choose">
          <div
            class="message"
            :class="{ choose: contentIndex === 0 }"
            @click="changeIndex(0)"
          >
            {{ $t("global.我关注的") }}
          </div>
          <div
            class="modify-password"
            :class="{ choose: contentIndex === 1 }"
            @click="changeIndex(1)"
          >
            {{ $t("global.我创建的") }}
          </div>
          <div
            class="creatChannel"
            v-if="contentIndex === 1"
            @click="GotoUrl('/subject/create/step1')"
          >
            <img
              src="https://image.manamana.net/1615974211000_LURBpter"
              alt=""
            />{{ $t("global.创建频道") }}
          </div>
          <!--<span>|</span>
          <div :class="{'choose':contentIndex===2}" @click="changeIndex(2)">{{$t('global.讨论区')}}</div>-->
        </div>
        <div class="myJoinWrap" v-if="commentShow">
          <div class="content-wrap clearfix">
            <!-- <div
              class="subject-item item subject-add"
              v-if="contentIndex === 1"
              @click="GotoUrl('/subject/create/step1')"
            >
              {{ $t("global.创建频道") }}
            </div> -->
            <div
              class="item"
              v-for="(item, index) in list"
              :key="index"
              @mouseenter="indexNumber = index"
              @mouseleave="indexNumber = null"
            >
              <router-link :to="'/subjectdetail/' + item.id">
                <div
                  :style="item.banner | bgImageUrl('', 313, 178)"
                  class="item-img"
                >
                </div>
              </router-link>
              <div class="content">
                <div
                  class="top"
                  @click="goToDetail(item)"
                  style="-webkit-box-orient: vertical"
                >
                  {{ item.title }}
                </div>
                <div class="bottom">{{ item.introduction }}</div>
                <div class="center">
                  <span class="videoSpan"
                    >{{ $t("global.视频") }} {{ item.videoCount || 0 }}</span
                  ><span>{{ $t("global.成员") }} {{ item.memberCount }}</span>
                </div>
                <div
                  class="hoverDiv1"
                  v-if="indexNumber == index && contentIndex === 0"
                  @click.self.prevent="open6(item.id, index)"
                >
                  {{ $t("global.取消关注") }}
                </div>
                <div
                  class="hoverDiv2"
                  v-if="indexNumber == index && contentIndex === 1"
                  @click.self.prevent="goToEdit(item)"
                >
                  <img
                    src="https://image.manamana.net/1615974262000_chyehdQg"
                    alt=""
                  />{{ $t("global.编辑") }}
                </div>
              </div>
            </div>
            <div class="noListData" v-if="!list.length">
              <img src="/static/peopleCenter/channel_empty@2x.png" alt="">
              <p>{{contentIndex===0?$t('people.还没有关注频道'):$t('people.还没有创建频道')}}</p>
            </div>
          </div>

          <pages
            :page-size="pagerParam.pageSize"
            :page-count="pagerParam.pageCount"
            :current-page="pagerParam.currentPage"
            :total="pagerParam.total"
            @current-page-changed="OnCurrentPageChanged"
          ></pages>
        </div>

        <div v-if="contentIndex === 2" class="dicusscontent">
          <div class="commentnav">
            <ul>
              <li :class="{ active: isActive == 0 }" @click="changeStyle(0)">
                {{ $t("global.主页") }}
              </li>
              <li :class="{ active: isActive == 1 }" @click="changeStyle(1)">
                {{ $t("global.发布") }}
              </li>
              <li :class="{ active: isActive == 2 }" @click="changeStyle(2)">
                {{ $t("global.回复") }}
              </li>
              <li :class="{ active: isActive == 3 }" @click="changeStyle(3)">
                {{ $t("global.收藏") }}
              </li>
              <li :class="{ active: isActive == 4 }" @click="changeStyle(4)">
                {{ $t("global.点赞") }}
              </li>
            </ul>
          </div>
          <div class="dicusslist1" v-if="changelist">
            <h3>
              {{ $t("global.发布的讨论") }}
              <a @click="checkAlls(1)">
                {{ $t("global.查看全部") }}
                <em>{{ newObj.newCount }}</em>
              </a>
            </h3>
            <ul>
              <li v-for="item in newObj.newList" :Key="item.id">
                <router-link
                  target="_blank"
                  :to="{
                    path: `/discussDetail?id=${item.id}&author=${item.userId}&topicId=${item.topicId}`,
                  }"
                  class="titlestyle"
                  >{{ item.title }}</router-link
                >
                <span
                  class="userState statewidth"
                  :class="{
                    addcolor1: item.status == 1,
                    addcolor2: item.status == 2,
                    addcolor3: item.status == 3,
                  }"
                  >{{ getStatus(item.status) }}</span
                >
                <a class="backinfor">
                  <em>{{ item.answerCount }}</em>
                  {{ $t("global.回复") }}
                </a>
                <a class="timeinfor">{{ timeStamp(item.updateTime) }}</a>
                <router-link
                  :to="`/subjectdetail/${item.topicId}/activity`"
                  class="writings"
                  >{{ item.topicName }}</router-link
                >
              </li>
            </ul>
          </div>

          <div class="dicusslist1 dicusslist2" v-if="changelist">
            <h3>
              {{ $t("global.回复的讨论") }}
              <a @click="checkAlls(2)">
                {{ $t("global.查看全部") }}
                <em>{{ likeObj.likeCount }}</em>
              </a>
            </h3>
            <ul>
              <li v-for="item in likeObj.likeList" :key="item.id">
                <router-link
                  target="_blank"
                  :to="`/discussDetail?id=${item.id}&author=${item.userId}&topicId=${item.topicId}`"
                  class="titlestyle"
                  >{{ item.title }}</router-link
                >
                <a class="backinfor">
                  <em>{{ item.answerCount }}</em>
                  {{ $t("global.回复") }}
                </a>
                <a class="timeinfor">{{ timeStamp(item.updateTime) }}</a>
                <router-link
                  :to="`/subjectdetail/${item.topicId}/activity`"
                  class="writings"
                  >{{ item.topicName }}</router-link
                >
              </li>
            </ul>
          </div>

          <div class="dicusslist1 dicusslist2" v-if="changelist">
            <h3>
              {{ $t("global.点赞的讨论") }}
              <a @click="checkAlls(3)">
                {{ $t("global.查看全部") }}
                <em>{{ answerObj.answerCount }}</em>
              </a>
            </h3>
            <ul>
              <li v-for="item in answerObj.answerList" :key="item.id">
                <router-link
                  target="_blank"
                  :to="`/discussDetail?id=${item.id}&author=${item.userId}&topicId=${item.topicId}`"
                  class="titlestyle"
                  >{{ item.title }}</router-link
                >
                <a class="backinfor">
                  <em>{{ item.answerCount }}</em>
                  {{ $t("global.回复") }}
                </a>
                <a class="timeinfor">{{ timeStamp(item.updateTime) }}</a>
                <router-link
                  :to="`/subjectdetail/${item.topicId}/activity`"
                  class="writings"
                  >{{ item.topicName }}</router-link
                >
              </li>
            </ul>
          </div>

          <div class="dicusslist1 dicusslist2" v-if="changelist">
            <h3>
              {{ $t("global.收藏的讨论") }}
              <a @click="checkAlls(4)">
                {{ $t("global.查看全部") }}
                <em>{{ collectObj.collectCount }}</em>
              </a>
            </h3>
            <ul>
              <li v-for="item in collectObj.collectList" :key="item.id">
                <router-link
                  target="_blank"
                  :to="`/discussDetail?id=${item.id}&author=${item.userId}&topicId=${item.topicId}`"
                  class="titlestyle"
                  >{{ item.title }}</router-link
                >
                <a class="backinfor">
                  <em>{{ item.answerCount }}</em>
                  {{ $t("global.回复") }}
                </a>
                <a class="timeinfor">{{ timeStamp(item.updateTime) }}</a>
                <router-link
                  :to="`/subjectdetail/${item.topicId}/activity`"
                  class="writings"
                  >{{ item.topicName }}</router-link
                >
              </li>
            </ul>
          </div>

          <!--存放数据组件-->
          <storageDicussData
            v-if="showData"
            :order-by="order"
            :is-show="showData"
          ></storageDicussData>
        </div>
      </div>
    </div>
    <service></service>
  </main-layout>
</template>

<script type="text/ecmascript-6">
import MainLayout from "@/layouts/MainLayout";
import service from "@/components/service.vue";
import asideCom from "@/components/aside.vue";
import pages from "@/components/pages.vue";
import ContentEmpty from "@/components/ContentEmpty.vue";
import storageDicussData from "./storageDicussData.vue";

export default {
  name: "MySpecialSubject",
  metaInfo() {
    return {
      title: this.$t("global.我的频道") + " | MANA",
    };
  },
  data() {
    return {
      contentIndex: 0,
      dataIndex: 2,
      list: [],
      listLength: -1,
      commentShow: true,
      isActive: 0,
      changelist: true,
      showData: false,
      indexNumber: null,
      num: 0,
      pagerParam: {
        pageSize: 15,
        pageCount: 1,
        currentPage: 1,
        total: 1,
      },

      //讨论区数据
      newObj: { newList: [], newCount: 0 },
      likeObj: { likeList: [], likeCount: 0 },
      answerObj: { answerList: [], answerCount: 0 },
      collectObj: { collectList: [], collectCount: 0 },
      order: 0,
    };
  },
  components: {
    MainLayout,
    service,
    asideCom,
    pages,
    ContentEmpty,
    storageDicussData,
  },
  computed: {
    content() {
      if (this.contentIndex === 0) {
        return this.$t("global.没有加入的频道");
      } else if (this.contentIndex === 1) {
        return this.$t("global.没有创建的频道");
      }
    },
  },
  created() {
    this.mySubject();
  },
  methods: {
    GotoUrl(url) {
      this.$router.push(url);
    },
    goToEdit(item) {
      this.$router.push(`/subject/edit/${item.id}/step1`);
    },
    goToDetail(item) {
      this.$router.push("/subjectdetail/" + item.id);
    },
    changeIndex(index) {
      this.contentIndex = index;
      switch (index) {
        case 0:
          this.dataIndex = 2;
          this.commentShow = true;
          break;
        case 1:
          this.dataIndex = 1;
          this.commentShow = true;
          break;
        case 2:
          this.commentShow = false;
          this.getQuestionCenter();
          break;
      }

      this.mySubject(1);
    },
    getQuestionCenter() {
      this.$http
        .get("api/u/topicquestion/getQuestionCenter", {
          params: { pageIndex: 1, pageSize: 5 },
        })
        .then((response) => {
          if (response.code == "OK") {
            let data = response.data;
            this.newObj.newCount = data.newCount;
            this.newObj.newList = data.newList;
            //
            this.likeObj.likeCount = data.likeCount;
            this.likeObj.likeList = data.likeList;
            //
            this.answerObj.answerCount = data.answerCount;
            this.answerObj.answerList = data.answerList;

            this.collectObj.collectCount = data.collectCount;
            this.collectObj.collectList = data.collectList;
          }
        });
    },
    getStatus(val) {
      let str = "";
      switch (val) {
        case 1:
          str = this.$t("global.待审核");
          break;
        case 2:
          str = this.$t("global.审核通过");
          break;
        case 3:
          str = this.$t("global.不通过");
          break;
        case -1:
          str = this.$t("global.已删除");
          break;
      }
      return str;
    },
    changeStyle(style) {
      this.isActive = style;
      switch (style) {
        case 0:
          this.showData = false;
          this.changelist = true;
          break;
      }

      if (style != 0) {
        this.checkAlls(style);
      }
    },
    checkAlls(num) {
      switch (num) {
        case 1:
          this.showData = true;
          this.changelist = false;
          break;
        case 2:
          this.showData = true;
          this.changelist = false;
          break;
        case 3:
          this.showData = true;
          this.changelist = false;
          break;
        case 4:
          this.showData = true;
          this.changelist = false;
          break;
      }
      this.isActive = num;
      this.order = num;
    },
    open6(id, index) {
      this.$confirm(
        `${this.$t("global.离开频道后")}，${this.$t(
          "global.将收不到频道内任何内容"
        )}`,
        this.$t("global.离开频道"),
        {
          confirmButtonText: this.$t("global.确定"),
          cancelButtonText: this.$t("global.取消"),
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.levelSubject(id, index);
      });
    },
    mySubject(pageI) {
      this.$http
        .get("/api/u/topic/center/myTopicList", {
          params: {
            type: this.dataIndex,
            pageIndex: pageI || this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize,
          },
        })
        .then((response) => {
          let data = response.data;
          this.list = data.list;
          this.pagerParam.pageSize = data.pageSize;
          this.pagerParam.total = data.totalRecord;
          this.pagerParam.pageCount = data.totalPage;
          this.pagerParam.currentPage = data.pageIndex;
          this.listLength = this.list.length;
        });
    },
    levelSubject(id, index) {
      this.$http
        .post("/api/u/topic/leave", {
          topicId: id,
        })
        .then((response) => {
          this.list.splice(index, 1);
          this.$message({
            type: "success",
            message: this.$t("global.删除成功"),
          });
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.mySubject(0);
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.myJoinWrap, .myCreateWrap {
  // padding: 20px;
}

.el-tooltip__popper.is-light {
  border: none;
}

.operate:hover {
  background-color: #180826 !important;
  border-radius: 0.08rem;
}

.operate {
  width: 0.74rem;
  height: 0.3rem;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.12rem 0;
  background: url('/static/peopleCenter/dot.png') no-repeat;
  background-size: 100%;
  border: none !important;

  span {
    display: block;
  }
}

.line {
  display: inline-block;
  margin: 0 0.1rem 0 0.14rem;
}

.myJoinWrap {
  width: 825px;
  padding-top: 25px;
}

.item {
  float: left;
  height: 210px;
  width: 253px;
  background: #ffffff;
  border: 1px solid #E0E0E0;
  margin-right: 30px;
  margin-bottom: 30px;

  &:nth-child(3n) {
    margin-right: 0;
  }
}
.noListData {
  text-align: center;
  padding-top: 120px;
  img{
    width: 88px;
    height: 88px;
    margin-bottom: 30px;
  }
  p{
    height: 21px;
    font-size: 15px;
    font-weight: 400;
    color: #B8B8B8;
    line-height: 21px;
  }
}
.item-img {
  position: relative;
  height: 72px;
  background: url('/static/peopleCenter/item.png') no-repeat;
  background-size: cover;
}

.level {
  cursor: pointer;
}

.content {
  padding: 0 15px;
  position: relative;

  .top {
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin-top: 0.16rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .center {
    font-size: 12px;
    font-weight: 400;
    color: #999999;

    .videoSpan {
      margin-right: 12px;
    }
  }

  .bottom {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
    height: 36px;
    margin: 10px 0 16px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    -webkit-line-clamp: 2;
    word-break: break-word;
  }

  .hoverDiv1 {
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border: 1px solid #999999;
    position: absolute;
    bottom: -5px;
    right: 15px;
    font-size: 12px;
    font-weight: 600;
    color: #999999;
    cursor: pointer;
  }

  .hoverDiv2 {
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border: 1px solid #3664ED;
    position: absolute;
    bottom: -5px;
    right: 15px;
    font-size: 12px;
    font-weight: 400;
    color: #3664ED;
    cursor: pointer;
    img{
      width: 12px;
      height: 12px;
      margin-right: 4px;
      margin-bottom: 2px;
    }
  }
}

.my-content {
  width: 825px;
  padding-top: 16px;

  .name {
    height: 30px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 30px;
    margin-bottom: 12px;
  }

  .top-choose {
    width: 100%;
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    position: relative;

    .message {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      padding: 0 2px;
      margin-right: 40px;
      height: 34px;
      cursor: pointer;
    }

    .modify-password {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      padding: 0 2px;
      height: 34px;
      cursor: pointer;
    }

    .creatChannel {
      position: absolute;
      width: 126px;
      height: 36px;
      background: #2026CC;
      line-height: 36px;
      text-align: center;
      font-size: 15px;
      font-weight: 400;
      color: #FFFFFF;
      bottom: 12px;
      right: 0;
      cursor: pointer;

      img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
        margin-bottom: 2px;
      }
    }

    .choose {
      font-weight: 600;
      color: #333333;
      border-bottom: 2px solid rgba(51, 51, 51, 1);
    }
  }
}
.body{
  background: #FAFAFA;
}
.container {
  width: 1110px;
  padding: 40px 0 120px 0;
  display: flex;
  margin: 0 auto;
  background: #FAFAFA;
}
</style>
<style lang="stylus">
.special-subject {
  .subject-item {
    cursor: pointer;
    display: block;
    float: left;
    width: 3.8rem;
    margin: 0.13rem;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    height: 3.9rem;
    position: relative;
    padding-bottom: 0.3rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 2px 2px 2px #eaeaea;
    -moz-box-shadow: 2px 2px 2px #eaeaea;
    box-shadow: 2px 2px 2px #eaeaea;
  }

  .subject-add {
    position: relative;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 2.6rem;
    text-align: center;
    font-size: 0.22rem;
    color: #333333;
    height: 298px;
    width: 312px;
    margin: 0.26rem 1rem 0 0;
    background: #fff;
    box-shadow: 2px 2px 2px #eaeaea;
    border-radius: 0.08rem;
  }

  .subject-add:before {
    content: '';
    display: block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    left: 0.1rem;
    top: 0.1rem;
    border: 2px dotted #e1e1e1;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    height: 290px;
    width: 304px;
  }

  .subject-add:after {
    content: '';
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    background: url('/static/explore/add.png') no-repeat center center;
    background-size: contain;
    position: absolute;
    left: 1.5rem;
    top: 1.5rem;
  }

  em {
    font-style: normal;
  }

  .dicusscontent .commentnav {
    color: #999;
    font-size: 16px;
    margin: 30px 0;
    overflow: hidden;
  }

  .dicusscontent .commentnav li {
    float: left;
    cursor: pointer;
    margin-right: 20px;
  }

  .dicusscontent .commentnav li.active {
    color: #333;
    font-weight: bold;
  }

  .dicusslist1 h3 {
    font-weight: normal;
    font-size: 20px;
    color: #999;
    margin-bottom: 7px;
  }

  .dicusslist1 h3 a em {
    font-style: normal;
    margin-left: 3px;
  }

  .dicusslist1 h3 a {
    color: #4A90E2;
    font-size: 14px;
    margin-left: 10px;
    cursor: pointer;
  }

  .dicusslist1 li {
    height: 18px;
    padding: 10px 0;
    line-height: 18px;
    font-size: 12px;
    border-bottom: 1px solid #e2e2e2;
  }

  .dicusslist1 li>* {
    float: left;
  }

  .dicusslist1 li .title {
    padding: 1px 7px;
    color: #fff;
    border-radius: 3px;
    background-color: #DF7979;
  }

  .dicusslist1 li .btncolor1 {
    background-color: #4A90E2;
  }

  .dicusslist1 li .titlestyle {
    font-size: 14px;
    color: #333;
    width: 356px;
    margin: 0 20px 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }

  .dicusslist1 li .addcolor1 {
    color: #F5A623;
  }

  .dicusslist1 li .statewidth {
    display: inline-block;
    width: 76px;
    margin-right: 30px;
  }

  .dicusslist1 li .addcolor2 {
    color: #34BA9C;
  }

  .dicusslist1 li .addcolor3 {
    position: relative;
    color: #D0021B;
  }

  .dicusslist1 li .backinfor {
    width: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dicusslist1 li .timeinfor {
    width: 62px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dicusslist1 li .backinfor, .dicusslist1 li .timeinfor {
    margin-right: 22px;
    font-size: 12px;
    color: #999;
    height: 16px;
    line-height: 16px;
  }

  .dicusslist1 li .writings {
    color: #4A90E2;
    font-size: 12px;
    max-width: 130px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dicusslist1 li .questions {
    padding: 1px 7px;
    color: #fff;
    border-radius: 3px;
    background-color: #4A90E2;
  }

  .dicusslist2 {
    margin-top: 55px;
  }

  .dicusslist2 li .titlestyle {
    margin-right: 150px;
  }

  .dicusslist1 li:last-child {
    border-bottom: none;
  }

  .dicusslist1 li img {
    position: relative;
    top: -2px;
    left: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  .dicusslist1 li .hovershow {
    position: absolute;
    opacity: 0;
    width: 200px;
    height: 40px;
    top: 35px;
    left: 0;
    color: #999;
    padding: 2px 6px;
    font-size: 14px;
    border-radius: 3px;
    overflow: hidden;
    box-shadow: 1px 1px 3px #ccc;
    text-overflow: ellipsis;
    background-color: #f4f4f4;
  }

  .dicusslist1 li img:hover + .hovershow {
    opacity: 1;
    -webkit-transform: translateY(-7px);
    transform: translateY(-7px);
    -webkit-transition: all 0.2s ease-in;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/my/account/SpecialSubject.vue